import { render, staticRenderFns } from "./LmGaiaLinksRenderer.vue?vue&type=template&id=65815bb4"
import script from "./LmGaiaLinksRenderer.vue?vue&type=script&lang=js"
export * from "./LmGaiaLinksRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports